import request from "@/utils/request";

export function getSearchLocation(data) {
  return request({
    url: "/mgr/location/getSearchLocation",
    method: "get",
    params: data,
  });
}

export function getItemOfLocation(data) {
  return request({
    url: "/mobile/stockTake/getItemOfLocation",
    method: "get",
    params: data,
  });
}

export function markAsChecked(stockItemID) {
  return request({
    url: `/mobile/stockTake/markAsChecked/${stockItemID}`,
    method: "post",
  });
}

export function getAcq(acqId) {
  return request({
    url: `/mobile/stockTake/getAcq/${acqId}`,
    method: "get",
  });
}

export function moveCarToLocation(data) {
  return request({
    url: "/mobile/stockTake/moveCarToLocation",
    method: "put",
    data,
  });
}

export function getCarOfLocation(data) {
  return request({
    url: "/mobile/stockTake/getCarOfLocation",
    method: "get",
    params: data,
  });
}
